// Auth is now handled by the Orbis SSO service (src/features/auth/ssoClient.ts).
// This file is kept only for the `isMockAuthEnabled` flag so non-auth modules
// (http.ts, AuthContext.tsx) don't need to import from a feature directory.
export const isMockAuthEnabled = import.meta.env.VITE_USE_MOCK_AUTH === 'true';
